import React from 'react';
import CreativeChallenge from '../CreativeChallenge/CreativeChallenge';

const CreativeInstaList = ({
  onBackToCommunity
}) => {
  return (
    <div>
      <CreativeChallenge 
        isInstaList={true} 
        onBackToCommunity={onBackToCommunity}
      />
    </div>
  )
}

export default CreativeInstaList; 